import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "antd";
import { Parse } from "parse";
import "../style.less";
import ModalLogin from "../Login/modal";
import UrbanLogo from "../img/logoNoirpng.png";
class MainHeader extends Component {
  componentDidMount() {
    //console.log('CU : ', Parse.User.current§)
    if (Parse.User.current() === null) {
      this.props.disconnectUser();
    }
  }

  handleClick = e => {
    this.setState({
      current: e.key
    });
  };

  chooseLink() {
    if (
      this.props.user.login === false ||
      (this.props.user.login === true &&
        this.props.user.redirectToSignUp === true)
    ) {
      return (
        <Link to="/">
          <img src={UrbanLogo} alt="" style={{ width: "200px" }} />
        </Link>
      );
    } else if (
      this.props.user.login === true &&
      this.props.user.redirectToSignUp === false
    ) {
      return (
        <Link to="/agenda">
          <img src={UrbanLogo} alt="" style={styles.logoStyle} />
        </Link>
      );
    }
  }

  //bonne version
  render() {
    let displayModalLogin;
    if (
      this.props.user.login === false &&
      this.props.user.redirectToSignUp === false
    ) {
      displayModalLogin = "";
    } else if (
      this.props.user.login === true &&
      this.props.user.redirectToSignUp === true
    ) {
      displayModalLogin = "";
    } else if (
      this.props.user.login === true &&
      this.props.user.redirectToSignUp === false
    ) {
      displayModalLogin = "hide";
    }

    return (
        <div style={styles.menuContainer}>
          <div style={{width: "33.33%",display: "flex", flexDirection: "row", justifyContent:"flex-start", padding: 10, marginRight: 15}}>
            <Link to='/aide'>
              <Button
                type="default"
              >
                {`Besoin d'aide ?`}
              </Button>
            </Link>
          </div>
          <div style={{width: "33.33%", display: "flex", flexDirection: "row", justifyContent:"center", padding: 10}}>
            {this.chooseLink()}
          </div>
          <div style={{width: "33.33%", display: "flex", flexDirection: "row", justifyContent:"flex-end", padding: 10}} className={displayModalLogin}>
            <ModalLogin />
          </div>
        </div>
    );
  }
}
const styles = {
  menuContainer: {
    display: 'flex',
    flexDirection: "row",
    height: 60,
    width: "100%",
    background: "white",
    alignItems: "center",
    padding: 0,
  },
  logoStyle: {
    width: 168.67,
    height: 39.33
  }
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    onClickLink: e => {
      dispatch({ type: `CLICK_${e.key}` });
    },
    disconnectUser() {
      dispatch({ type: "disconnect" });
    }
  };
};

const connectedMainHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainHeader);
export default connectedMainHeader;
